(function GoldCardBookings($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Leads/listLeads', function onload()
		{
			$('.lead-products .item').click(function itemClicked(e) {
				var product_id = $(this).data("id");

				document.location = Adzuki.base_uri + '/Leads/purchase/' + product_id;
			});
		});
	});
}(jQuery, window.Adzuki || {}));
